import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { setElementFocus, hasSheetClassName, setFocus, defineSheetLayout, trapUpperBoundFocus, trapLowerBoundFocus } from './uitk-sheet-utilities.esm.js';
import styles from './uitk-sheet.css';

var getClassNameList = classNames.bind(styles);
var UitkSideSheet = function (props) {
    var _a;
    var _b = props.autoFocus, autoFocus = _b === void 0 ? true : _b, children = props.children, className = props.className, hasModal = props.hasModal, isVisible = props.isVisible, overflow = props.overflow, _c = props.returnFocusOnClose, returnFocusOnClose = _c === void 0 ? true : _c, sideSheetLayout = props.sideSheetLayout, triggerRef = props.triggerRef, _d = props.type, type = _d === void 0 ? 'side' : _d;
    var sheetRef = React.useRef(null);
    var baseClassName = "uitk-".concat(type, "-sheet");
    // Hooks
    // Set focus when initial mount only
    React.useEffect(function () {
        if (autoFocus && isVisible) {
            setElementFocus(sheetRef, true, hasModal);
        }
        hasModal && hasSheetClassName('add');
    }, [autoFocus, hasModal, isVisible]);
    // "unmount" hook
    React.useEffect(function () { return function () {
        if (returnFocusOnClose) {
            setFocus(triggerRef);
        }
        hasModal && hasSheetClassName('remove');
    }; }, [returnFocusOnClose, triggerRef]);
    var _e = defineSheetLayout(children), hasCloseButton = _e.hasCloseButton, layoutProps = _e.layoutProps, closeButtonLayoutProps = _e.closeButtonLayoutProps, closeButtonElem = _e.closeButtonElem, childrenElem = _e.childrenElem, footerElem = _e.footerElem;
    var layoutClasses = function (obj, cssBaseClass) {
        var layoutObj = obj;
        if (!('position' in obj)) {
            layoutObj.position = 'trailing'; // Set 'trailing' default
        }
        var str = Object.entries(layoutObj)
            .map(function (_a) {
            var key = _a[0], val = _a[1];
            return "".concat(cssBaseClass, "-").concat(key, "-").concat(val);
        })
            .join(' ');
        return str;
    };
    var sheetClassNames = getClassNameList(baseClassName, sideSheetLayout && layoutClasses(sideSheetLayout, baseClassName), (_a = {},
        _a["".concat(baseClassName, "-position-trailing")] = !sideSheetLayout,
        _a["".concat(baseClassName, "-has-overflow")] = overflow,
        _a), className);
    return (React.createElement("section", { ref: sheetRef, className: sheetClassNames, tabIndex: -1 },
        hasModal && React.createElement("div", { tabIndex: 0, onFocus: trapUpperBoundFocus }),
        hasCloseButton && (React.createElement(UitkLayoutFlex, __assign({}, layoutProps),
            React.createElement(UitkLayoutFlexItem, __assign({}, closeButtonLayoutProps), closeButtonElem),
            React.createElement(UitkLayoutFlexItem, null, childrenElem))),
        !hasCloseButton && childrenElem,
        footerElem,
        hasModal && React.createElement("div", { tabIndex: 0, onFocus: trapLowerBoundFocus })));
};
UitkSideSheet.displayName = 'UitkSideSheet';

export { UitkSideSheet };
